"use strict";
/*
  This file is part of web3x.

  web3x is free software: you can redistribute it and/or modify
  it under the terms of the GNU Lesser General Public License as published by
  the Free Software Foundation, either version 3 of the License, or
  (at your option) any later version.

  web3x is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Lesser General Public License for more details.

  You should have received a copy of the GNU Lesser General Public License
  along with web3x.  If not, see <http://www.gnu.org/licenses/>.
*/

var _objectWithoutProperties = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var providers_1 = require("../providers");

var eth_request_payloads_1 = require("./eth-request-payloads");

var send_tx_1 = require("./send-tx");

var logs_1 = require("./subscriptions/logs");

var new_heads_1 = require("./subscriptions/new-heads");

var new_pending_transactions_1 = require("./subscriptions/new-pending-transactions");

var syncing_1 = require("./subscriptions/syncing");

var Eth = /*#__PURE__*/function () {
  function Eth(provider) {
    _classCallCheck(this, Eth);

    this.provider = provider;
    this.request = new eth_request_payloads_1.EthRequestPayloads(undefined, 'latest');
  }

  _createClass(Eth, [{
    key: "send",
    value: function () {
      var _send = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
        var method, params, format;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                method = _ref.method, params = _ref.params, format = _ref.format;
                _context.t0 = format;
                _context.next = 4;
                return this.provider.send(method, params);

              case 4:
                _context.t1 = _context.sent;
                return _context.abrupt("return", (0, _context.t0)(_context.t1));

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function send(_x) {
        return _send.apply(this, arguments);
      }

      return send;
    }()
  }, {
    key: "getId",
    value: function () {
      var _getId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.send(this.request.getId());

              case 2:
                return _context2.abrupt("return", _context2.sent);

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getId() {
        return _getId.apply(this, arguments);
      }

      return getId;
    }()
  }, {
    key: "getNodeInfo",
    value: function () {
      var _getNodeInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.send(this.request.getNodeInfo());

              case 2:
                return _context3.abrupt("return", _context3.sent);

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getNodeInfo() {
        return _getNodeInfo.apply(this, arguments);
      }

      return getNodeInfo;
    }()
  }, {
    key: "getProtocolVersion",
    value: function () {
      var _getProtocolVersion = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.send(this.request.getProtocolVersion());

              case 2:
                return _context4.abrupt("return", _context4.sent);

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getProtocolVersion() {
        return _getProtocolVersion.apply(this, arguments);
      }

      return getProtocolVersion;
    }()
  }, {
    key: "getCoinbase",
    value: function () {
      var _getCoinbase = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.send(this.request.getCoinbase());

              case 2:
                return _context5.abrupt("return", _context5.sent);

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getCoinbase() {
        return _getCoinbase.apply(this, arguments);
      }

      return getCoinbase;
    }()
  }, {
    key: "isMining",
    value: function () {
      var _isMining = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.send(this.request.isMining());

              case 2:
                return _context6.abrupt("return", _context6.sent);

              case 3:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function isMining() {
        return _isMining.apply(this, arguments);
      }

      return isMining;
    }()
  }, {
    key: "getHashrate",
    value: function () {
      var _getHashrate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.send(this.request.getHashrate());

              case 2:
                return _context7.abrupt("return", _context7.sent);

              case 3:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function getHashrate() {
        return _getHashrate.apply(this, arguments);
      }

      return getHashrate;
    }()
  }, {
    key: "isSyncing",
    value: function () {
      var _isSyncing = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this.send(this.request.isSyncing());

              case 2:
                return _context8.abrupt("return", _context8.sent);

              case 3:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function isSyncing() {
        return _isSyncing.apply(this, arguments);
      }

      return isSyncing;
    }()
  }, {
    key: "getGasPrice",
    value: function () {
      var _getGasPrice = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return this.send(this.request.getGasPrice());

              case 2:
                return _context9.abrupt("return", _context9.sent);

              case 3:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function getGasPrice() {
        return _getGasPrice.apply(this, arguments);
      }

      return getGasPrice;
    }()
  }, {
    key: "getAccounts",
    value: function () {
      var _getAccounts = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return this.send(this.request.getAccounts());

              case 2:
                return _context10.abrupt("return", _context10.sent);

              case 3:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function getAccounts() {
        return _getAccounts.apply(this, arguments);
      }

      return getAccounts;
    }()
  }, {
    key: "getBlockNumber",
    value: function () {
      var _getBlockNumber = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return this.send(this.request.getBlockNumber());

              case 2:
                return _context11.abrupt("return", _context11.sent);

              case 3:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function getBlockNumber() {
        return _getBlockNumber.apply(this, arguments);
      }

      return getBlockNumber;
    }()
  }, {
    key: "getBalance",
    value: function () {
      var _getBalance = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(address, block) {
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return this.send(this.request.getBalance(address, block));

              case 2:
                return _context12.abrupt("return", _context12.sent);

              case 3:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function getBalance(_x2, _x3) {
        return _getBalance.apply(this, arguments);
      }

      return getBalance;
    }()
  }, {
    key: "getStorageAt",
    value: function () {
      var _getStorageAt = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(address, position, block) {
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.next = 2;
                return this.send(this.request.getStorageAt(address, position, block));

              case 2:
                return _context13.abrupt("return", _context13.sent);

              case 3:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function getStorageAt(_x4, _x5, _x6) {
        return _getStorageAt.apply(this, arguments);
      }

      return getStorageAt;
    }()
  }, {
    key: "getCode",
    value: function () {
      var _getCode = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(address, block) {
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.next = 2;
                return this.send(this.request.getCode(address, block));

              case 2:
                return _context14.abrupt("return", _context14.sent);

              case 3:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function getCode(_x7, _x8) {
        return _getCode.apply(this, arguments);
      }

      return getCode;
    }()
  }, {
    key: "getBlock",
    value: function () {
      var _getBlock = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(block, returnTxs) {
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.next = 2;
                return this.send(this.request.getBlock(block, returnTxs));

              case 2:
                return _context15.abrupt("return", _context15.sent);

              case 3:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function getBlock(_x9, _x10) {
        return _getBlock.apply(this, arguments);
      }

      return getBlock;
    }()
  }, {
    key: "getUncle",
    value: function () {
      var _getUncle = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(block, uncleIndex, returnTxs) {
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.next = 2;
                return this.send(this.request.getUncle(block, uncleIndex, returnTxs));

              case 2:
                return _context16.abrupt("return", _context16.sent);

              case 3:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function getUncle(_x11, _x12, _x13) {
        return _getUncle.apply(this, arguments);
      }

      return getUncle;
    }()
  }, {
    key: "getBlockTransactionCount",
    value: function () {
      var _getBlockTransactionCount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(block) {
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                _context17.next = 2;
                return this.send(this.request.getBlockTransactionCount(block));

              case 2:
                return _context17.abrupt("return", _context17.sent);

              case 3:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function getBlockTransactionCount(_x14) {
        return _getBlockTransactionCount.apply(this, arguments);
      }

      return getBlockTransactionCount;
    }()
  }, {
    key: "getBlockUncleCount",
    value: function () {
      var _getBlockUncleCount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(block) {
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                _context18.next = 2;
                return this.send(this.request.getBlockUncleCount(block));

              case 2:
                return _context18.abrupt("return", _context18.sent);

              case 3:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));

      function getBlockUncleCount(_x15) {
        return _getBlockUncleCount.apply(this, arguments);
      }

      return getBlockUncleCount;
    }()
  }, {
    key: "getTransaction",
    value: function () {
      var _getTransaction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(hash) {
        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                _context19.next = 2;
                return this.send(this.request.getTransaction(hash));

              case 2:
                return _context19.abrupt("return", _context19.sent);

              case 3:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this);
      }));

      function getTransaction(_x16) {
        return _getTransaction.apply(this, arguments);
      }

      return getTransaction;
    }()
  }, {
    key: "getTransactionFromBlock",
    value: function () {
      var _getTransactionFromBlock = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(block, index) {
        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                _context20.next = 2;
                return this.send(this.request.getTransactionFromBlock(block, index));

              case 2:
                return _context20.abrupt("return", _context20.sent);

              case 3:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, this);
      }));

      function getTransactionFromBlock(_x17, _x18) {
        return _getTransactionFromBlock.apply(this, arguments);
      }

      return getTransactionFromBlock;
    }()
  }, {
    key: "getTransactionReceipt",
    value: function () {
      var _getTransactionReceipt = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21(txHash) {
        return _regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                _context21.next = 2;
                return this.send(this.request.getTransactionReceipt(txHash));

              case 2:
                return _context21.abrupt("return", _context21.sent);

              case 3:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, this);
      }));

      function getTransactionReceipt(_x19) {
        return _getTransactionReceipt.apply(this, arguments);
      }

      return getTransactionReceipt;
    }()
  }, {
    key: "getTransactionCount",
    value: function () {
      var _getTransactionCount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22(address, block) {
        return _regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                _context22.next = 2;
                return this.send(this.request.getTransactionCount(address, block));

              case 2:
                return _context22.abrupt("return", _context22.sent);

              case 3:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, this);
      }));

      function getTransactionCount(_x20, _x21) {
        return _getTransactionCount.apply(this, arguments);
      }

      return getTransactionCount;
    }()
  }, {
    key: "signTransaction",
    value: function () {
      var _signTransaction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23(tx) {
        return _regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                _context23.next = 2;
                return this.send(this.request.signTransaction(tx));

              case 2:
                return _context23.abrupt("return", _context23.sent);

              case 3:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, this);
      }));

      function signTransaction(_x22) {
        return _signTransaction.apply(this, arguments);
      }

      return signTransaction;
    }()
  }, {
    key: "sendSignedTransaction",
    value: function sendSignedTransaction(data) {
      var _this$request$sendSig = this.request.sendSignedTransaction(data),
          method = _this$request$sendSig.method,
          params = _this$request$sendSig.params;

      var txHashPromise = this.provider.send(method, params);
      return new send_tx_1.SentTransaction(this, txHashPromise);
    }
  }, {
    key: "sendTransaction",
    value: function sendTransaction(tx) {
      var _this = this;

      var promise = new Promise( /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee24(resolve, reject) {
          var account, _this$request$sendTra, method, params, format, txHash, from, fromlessTx, signedTx, _this$request$sendSig2, _method, _params, _format, _txHash;

          return _regeneratorRuntime.wrap(function _callee24$(_context24) {
            while (1) {
              switch (_context24.prev = _context24.next) {
                case 0:
                  _context24.prev = 0;

                  if (tx.gasPrice) {
                    _context24.next = 5;
                    break;
                  }

                  _context24.next = 4;
                  return _this.getGasPrice();

                case 4:
                  tx.gasPrice = _context24.sent;

                case 5:
                  account = _this.getAccount(tx.from);

                  if (account) {
                    _context24.next = 16;
                    break;
                  }

                  _this$request$sendTra = _this.request.sendTransaction(tx), method = _this$request$sendTra.method, params = _this$request$sendTra.params, format = _this$request$sendTra.format;
                  _context24.t0 = format;
                  _context24.next = 11;
                  return _this.provider.send(method, params);

                case 11:
                  _context24.t1 = _context24.sent;
                  txHash = (0, _context24.t0)(_context24.t1);
                  resolve(txHash);
                  _context24.next = 27;
                  break;

                case 16:
                  from = tx.from, fromlessTx = _objectWithoutProperties(tx, ["from"]);
                  _context24.next = 19;
                  return account.signTransaction(fromlessTx, _this);

                case 19:
                  signedTx = _context24.sent;
                  _this$request$sendSig2 = _this.request.sendSignedTransaction(signedTx.rawTransaction), _method = _this$request$sendSig2.method, _params = _this$request$sendSig2.params, _format = _this$request$sendSig2.format;
                  _context24.t2 = _format;
                  _context24.next = 24;
                  return _this.provider.send(_method, _params);

                case 24:
                  _context24.t3 = _context24.sent;
                  _txHash = (0, _context24.t2)(_context24.t3);
                  resolve(_txHash);

                case 27:
                  _context24.next = 32;
                  break;

                case 29:
                  _context24.prev = 29;
                  _context24.t4 = _context24["catch"](0);
                  reject(_context24.t4);

                case 32:
                case "end":
                  return _context24.stop();
              }
            }
          }, _callee24, null, [[0, 29]]);
        }));

        return function (_x23, _x24) {
          return _ref2.apply(this, arguments);
        };
      }());
      return new send_tx_1.SentTransaction(this, promise);
    }
  }, {
    key: "getAccount",
    value: function getAccount(address) {
      address = address || this.defaultFromAddress;

      if (this.wallet && address) {
        return this.wallet.get(address);
      }
    }
  }, {
    key: "sign",
    value: function () {
      var _sign = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee25(address, dataToSign) {
        var account, sig;
        return _regeneratorRuntime.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                account = this.getAccount(address);

                if (account) {
                  _context25.next = 7;
                  break;
                }

                _context25.next = 4;
                return this.send(this.request.sign(address, dataToSign));

              case 4:
                return _context25.abrupt("return", _context25.sent);

              case 7:
                sig = account.sign(dataToSign);
                return _context25.abrupt("return", sig.signature);

              case 9:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25, this);
      }));

      function sign(_x25, _x26) {
        return _sign.apply(this, arguments);
      }

      return sign;
    }()
  }, {
    key: "signTypedData",
    value: function () {
      var _signTypedData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee26(address, dataToSign) {
        return _regeneratorRuntime.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                _context26.next = 2;
                return this.send(this.request.signTypedData(address, dataToSign));

              case 2:
                return _context26.abrupt("return", _context26.sent);

              case 3:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26, this);
      }));

      function signTypedData(_x27, _x28) {
        return _signTypedData.apply(this, arguments);
      }

      return signTypedData;
    }()
  }, {
    key: "call",
    value: function () {
      var _call = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee27(tx, block) {
        return _regeneratorRuntime.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                _context27.next = 2;
                return this.send(this.request.call(tx, block));

              case 2:
                return _context27.abrupt("return", _context27.sent);

              case 3:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27, this);
      }));

      function call(_x29, _x30) {
        return _call.apply(this, arguments);
      }

      return call;
    }()
  }, {
    key: "estimateGas",
    value: function () {
      var _estimateGas = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee28(tx) {
        return _regeneratorRuntime.wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                _context28.next = 2;
                return this.send(this.request.estimateGas(tx));

              case 2:
                return _context28.abrupt("return", _context28.sent);

              case 3:
              case "end":
                return _context28.stop();
            }
          }
        }, _callee28, this);
      }));

      function estimateGas(_x31) {
        return _estimateGas.apply(this, arguments);
      }

      return estimateGas;
    }()
  }, {
    key: "submitWork",
    value: function () {
      var _submitWork = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee29(nonce, powHash, digest) {
        return _regeneratorRuntime.wrap(function _callee29$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                _context29.next = 2;
                return this.send(this.request.submitWork(nonce, powHash, digest));

              case 2:
                return _context29.abrupt("return", _context29.sent);

              case 3:
              case "end":
                return _context29.stop();
            }
          }
        }, _callee29, this);
      }));

      function submitWork(_x32, _x33, _x34) {
        return _submitWork.apply(this, arguments);
      }

      return submitWork;
    }()
  }, {
    key: "getWork",
    value: function () {
      var _getWork = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee30() {
        return _regeneratorRuntime.wrap(function _callee30$(_context30) {
          while (1) {
            switch (_context30.prev = _context30.next) {
              case 0:
                _context30.next = 2;
                return this.send(this.request.getWork());

              case 2:
                return _context30.abrupt("return", _context30.sent);

              case 3:
              case "end":
                return _context30.stop();
            }
          }
        }, _callee30, this);
      }));

      function getWork() {
        return _getWork.apply(this, arguments);
      }

      return getWork;
    }()
  }, {
    key: "getPastLogs",
    value: function () {
      var _getPastLogs = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee31(options) {
        return _regeneratorRuntime.wrap(function _callee31$(_context31) {
          while (1) {
            switch (_context31.prev = _context31.next) {
              case 0:
                _context31.next = 2;
                return this.send(this.request.getPastLogs(options));

              case 2:
                return _context31.abrupt("return", _context31.sent);

              case 3:
              case "end":
                return _context31.stop();
            }
          }
        }, _callee31, this);
      }));

      function getPastLogs(_x35) {
        return _getPastLogs.apply(this, arguments);
      }

      return getPastLogs;
    }()
  }, {
    key: "subscribe",
    value: function subscribe(type) {
      switch (type) {
        case 'logs':
          for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }

          return logs_1.subscribeForLogs.apply(logs_1, [this].concat(args));

        case 'syncing':
          return syncing_1.subscribeForSyncing(this.provider);

        case 'newBlockHeaders':
          return new_heads_1.subscribeForNewHeads(this.provider);

        case 'pendingTransactions':
          return new_pending_transactions_1.subscribeForNewPendingTransactions(this.provider);

        default:
          throw new Error("Unknown subscription type: ".concat(type));
      }
    }
  }, {
    key: "defaultFromAddress",
    get: function get() {
      return this.request.defaultFromAddress;
    },
    set: function set(address) {
      this.request.defaultFromAddress = address;
    }
  }], [{
    key: "fromCurrentProvider",
    value: function fromCurrentProvider() {
      if (typeof web3 === 'undefined') {
        return;
      }

      var provider = web3.currentProvider || web3.ethereumProvider;

      if (!provider) {
        return;
      }

      return new Eth(new providers_1.LegacyProviderAdapter(provider));
    }
  }]);

  return Eth;
}();

exports.Eth = Eth;